import { TRUE_APP } from './constants';
/**
 * Function to grab query parameters and put them where they need to go
 * takes the source paramter and puts it in session storage under source
 */
const setApplicationSource = () => {
  const searchParams = new URLSearchParams(window.location.search);
  const source = searchParams.get('source');

  if (source) {
    sessionStorage.setItem('source', source);
  } else if (window.location !== window.parent.location) {
    sessionStorage.setItem('source', TRUE_APP);
  }
};

export default setApplicationSource;
